import { LoadingIcon } from '@bfe/moly-icons';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useAsyncFn } from 'react-use';
import { userWalletStore } from '../../store/userWallet';
import { walletIdMap } from '../../utils/constants';
import { scTrack } from '../../utils/scTrack';
import { WalletTag, thirdPartyWallet } from '../../wallet-hub/Web3WalletHubCenter';
import { WalletHub } from '../../wallet-hub/core/WalletHub';
import { useWalletIsPending } from '../../wallet-hub/helpers/hooks';
import { evmWalletConnectHub, preloadWcConnectProvider } from '../../wallet-hub/hubs/WalletConnectHub';
import { addListener } from '../../wallet-hub/misc';

export type ThirdWalletListProps = {
  onConnect?: () => void;
};

const getWalletHubs = () => {
  return [evmWalletConnectHub, ...thirdPartyWallet.getWalletHubsByTag(WalletTag.config), ...thirdPartyWallet.getWalletHubsByTag(WalletTag.scan)];
};

const localTrack = (spmName: string) => {
  scTrack('Web3userClick', {
    page_name: 'web3sdk3rdPartyWallet',
    spmName,
  });
};
export function ThirdWalletList({ onConnect }: ThirdWalletListProps) {
  const [thirdWalletList, setThirdWalletList] = useState<WalletHub[]>(getWalletHubs());

  useEffect(() => {
    preloadWcConnectProvider();
  }, []);
  useEffect(() => {
    return addListener(thirdPartyWallet, 'walletHubChange', () => {
      setThirdWalletList(getWalletHubs());
    });
  }, []);

  const isSwitching = useWalletIsPending();

  const [switchingState, switchToWallet] = useAsyncFn(async (wallet: WalletHub) => {
    await wallet.initConnectors();
    const isAvailable = await wallet.isAvailable;
    if (isAvailable) {
      localTrack(wallet.name);
      await userWalletStore.switchToWallet(wallet.id);
      onConnect?.();
    } else if (wallet.installUrl) {
      window.open(wallet.installUrl);
    }
  });

  return (
    <ul className="third-party-wallet-list grid grid-cols-3 gap-x-[18px] gap-y-4 mt-8">
      {thirdWalletList.map((wallet) => (
        <li
          key={wallet.id}
          className={clsx(
            'third-party-wallet-list-item',
            'rounded py-6 px-4 cursor-pointer bg-bds-gray-ele-edge hover:bg-bds-trans-hover flex flex-col items-center',
            'relative',
          )}
          onClick={() => {
            if (switchingState.loading) {
              return;
            }
            switchToWallet(wallet);
          }}
        >
          <img className="size-8" src={wallet.icon} alt={wallet.name} />
          <h4 className="mt-2 font-medium">{wallet.name}</h4>
          {walletIdMap.walletConnect === wallet.id && (
            <div className="absolute top-0 right-0 translate-y-[-50%] bg-bds-gray-ele-border text-bds-gray-t2 text-[10px] leading-[14px] px-1">
              #QR Code
            </div>
          )}
          {isSwitching && (
            <div className="absolute top-0 bottom-0 right-0 left-0 flex items-center justify-center bg-bds-trans-mask rounded">
              <LoadingIcon className="animate-spin size-4 text-bds-brand-700-normal" />
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
